import { render, staticRenderFns } from "./FileManagerComponent.vue?vue&type=template&id=4df6d17a&scoped=true&lang=pug"
import script from "./FileManagerComponent.vue?vue&type=script&lang=ts"
export * from "./FileManagerComponent.vue?vue&type=script&lang=ts"
import style0 from "./FileManagerComponent.vue?vue&type=style&index=0&id=4df6d17a&lang=scss&scoped=true"
import style1 from "./FileManagerComponent.vue?vue&type=style&index=1&id=4df6d17a&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4df6d17a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4df6d17a')) {
      api.createRecord('4df6d17a', component.options)
    } else {
      api.reload('4df6d17a', component.options)
    }
    module.hot.accept("./FileManagerComponent.vue?vue&type=template&id=4df6d17a&scoped=true&lang=pug", function () {
      api.rerender('4df6d17a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/FileManager/FileManagerComponent.vue"
export default component.exports